import { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet-async';

export type HeadProps = {
  title: string;
};

const brandTitle = 'Grow Sales & Give Back';

export const Head: FunctionComponent<HeadProps> = (props) => {
  const { title } = props;
  return (
    <Helmet>
      <title> {`${title} | ${brandTitle}`} </title>
    </Helmet>
  );
};
